import { render } from "./PriceServicePageList.vue?vue&type=template&id=1535db67&scoped=true&ts=true"
import script from "./PriceServicePageList.vue?vue&type=script&lang=ts"
export * from "./PriceServicePageList.vue?vue&type=script&lang=ts"

import "./PriceServicePageList.vue?vue&type=style&index=0&id=1535db67&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1535db67"]])

export default __exports__